import { ref } from 'vue'
import { useRouter } from 'vue-router'
import apiClient from '@/api/client'
import { CONTENT, EMAILS } from '@/api/endpoints'
import type { Content } from '@/types/analysis'

interface GenerateEmailData {
  prompt: string
  content_id?: string
  institution_id?: string
  generate_for_all?: boolean
  use_bulk_generation?: boolean
  use_json_mode?: boolean
}

export function useEmailGeneration() {
  const router = useRouter()
  const generating = ref(false)
  const showSuccessMessage = ref(false)
  const successMessage = ref('')

  async function generateEmail(data: GenerateEmailData) {
    generating.value = true
    
    try {
      const response = await apiClient.post(EMAILS.GENERATE, {
        prompt: data.prompt,
        content_id: data.content_id,
        institution_id: data.institution_id,
        generate_for_all: data.generate_for_all,
        use_bulk_generation: data.use_bulk_generation,
        use_json_mode: data.use_json_mode
      })
      
      const generatedCount = Array.isArray(response.data) ? response.data.length : (response.data ? 1 : 0)
      if (generatedCount > 0) {
        successMessage.value = `Successfully generated ${generatedCount} email${generatedCount > 1 ? 's' : ''}`
        showSuccessMessage.value = true
        setTimeout(() => {
          showSuccessMessage.value = false
          successMessage.value = ''
        }, 3000)
      }

      return response.data
    } catch (error: any) {
      console.error('Error generating email:', error)
      const errorMessage = error.response?.data?.detail || error.message || 'Failed to generate email'
      alert(`Error: ${errorMessage.replace(/\\\\n/g, '\\n')}`)
      throw new Error(errorMessage.replace(/\\\\n/g, '\\n'))
    } finally {
      generating.value = false
    }
  }

  return {
    generating,
    showSuccessMessage,
    successMessage,
    generateEmail,
  }
} 